const { QuestionType } = require('./questions');

const questionTypes = [
    {
        text: 'Short text',
        value: QuestionType.SHORT,
        btnVariant: 'success'
    },
    {
        text: 'Long text',
        value: QuestionType.LONG,
        btnVariant: 'primary'
    },
    {
        text: 'WYSIWYG',
        value: QuestionType.WYSIWYG,
        btnVariant: 'danger'
    },
    {
        text: 'Number',
        value: QuestionType.NUMBER,
        btnVariant: 'danger'
    },
    {
        text: 'E-mail',
        value: QuestionType.EMAIL,
        btnVariant: 'warning'
    },
    {
        text: 'Checkbox',
        value: QuestionType.CHECKBOX,
        btnVariant: 'info'
    },
    {
        text: 'Dropdown',
        value: QuestionType.DROPDOWN,
        btnVariant: 'secondary'
    },
    {
        text: 'Multiple select',
        value: QuestionType.MULTI_SELECT,
        btnVariant: 'light'
    },
    {
        text: 'File',
        value: QuestionType.FILE,
        btnVariant: 'dark'
    }
];

module.exports = {
    questionTypes
};
